import getCookie from "helpers/getCookie";

const getUniAppHeaders = () => {
  const isUniApp = getCookie("is_uni_app");
  if (isUniApp !== "true") return {};

  const headers: Record<string, string> = { "is-uni-app": isUniApp };
  const appVersion = getCookie("x_app_version");
  const requestSource = getCookie("x_request_source");
  const requestSourceType = getCookie("x_request_source_type");

  if (appVersion) headers["x-app-version"] = appVersion;
  if (requestSource) headers["x-request-source"] = requestSource;
  if (requestSourceType) headers["x-request-source-type"] = requestSourceType;

  return headers;
};

export default getUniAppHeaders;
